
// export const TOPPER_HEIGHT = 65;
// export const PROJECT_HEADER_HEIGHT = 60;
export const COMMENT_INPUT_HEIGHT = 100;
export const SIDEBAR_WIDTH = 230;

export const BACKGROUND_GRADIENT_CSS = "radial-gradient(circle, #f9f871, #ffd477, #ffb697, #ffa5ba, #e5a1d0);";
export const TOPPER_GRADIENT_CSS = "radial-gradient(farthest-corner at 10px 80px, #f9f87180, #ffd47780, #ffb69780, #ffa5ba80, #e5a1d080);";
